import type { SerializeValueType } from "./types";

export const getTypeIcon = (type: string) => {
  switch (type) {
    case "string":
      return "text";
    case "number":
      return "hashtag";
    case "boolean":
      return "toggle-large-on";
    case "date":
      return "calendar";
    case "array":
      return "list";
    default:
      return "question";
  }
};

export const getTypeRepresentation = (type: string) => {
  switch (type) {
    case "string":
      return "str";
    case "number":
      return "num";
    case "boolean":
      return "bool";
    case "date":
      return "date";
    case "array":
      return "array";
    default:
      return "Desconocido";
  }
};

export const getLogicalOperatorName = (operator: string) => {
  switch (operator) {
    case "and":
      return "And";
    case "or":
      return "Or";
    case "not":
      return "& Not";
    default:
      return "Desconocido";
  }
};

/**
 * Parse saved value and supported value by app
 * TODO: merge with if value function
 *
 * @param type
 * @returns
 */
export const getValueType = (type: SerializeValueType) => {
  if (!type) return "NONE";
  switch (type) {
    case "string":
    case "regex":
      return "STRING";
    case "positive-integer":
    case "number":
      return "NUMBER";
    case "variable":
      return "MODEL";
    case "boolean":
      return "BOOLEAN";
    case "date":
      return "DATE";
    case "array":
      return "ARRAY";
    default:
      return "NONE";
  }
};

/**
 * Utility to parse and normalize comparative values that might be arrays.
 * Handles both actual arrays and JSON string representations of arrays.
 */
export const parseArrayValue = (
  comparativeValue: string | string[] | unknown,
): string[] => {
  // If it's already an array, return it
  if (Array.isArray(comparativeValue)) {
    return comparativeValue;
  }

  // If it's a string that looks like JSON array, try to parse it
  if (
    typeof comparativeValue === "string" &&
    comparativeValue.startsWith("[")
  ) {
    try {
      const parsed = JSON.parse(comparativeValue);
      if (Array.isArray(parsed)) {
        return parsed;
      }
    } catch {
      // If parsing fails, return empty array
    }
  }

  return [];
};
